<template>
  <router-view />
</template>

<route>
{
  "redirect": "/system/global_settings/administrators",
  "name": "System Global Settings"
}
</route>

<script>
import { mapActions } from "vuex";
export default {
  methods: mapActions("pageMeta", ["setPageTitle"]),
  created() {
    this.setPageTitle(this.$t("Settings"));
  },
};
</script>
